// extracted by mini-css-extract-plugin
module.exports = {"blue-text":"refundDetails_blue-text__yEtf_","flex":"refundDetails_flex__3ZIL_"};